const EG = {
  ibanLength: 27,
};
export { EG };
